export const fontWeight = {
	BOLD: 'bold',
	MEDIUM: 500,
	REGULAR: 'normal',
	LIGHT: 300,
};

export const fontSize = {
	LARGE: '16px',
	MEDIUM: '14px',
	SMALL: '13px',
	TINY: '12px',
};

// 這是基準1rem
const defaultFontSize = 14;

export const typography = () => ({
	fontFamily: `'Inter', sans-serif, 'Noto Sans CJK TC', '微軟正黑體'`,
	fontWeightRegular: fontWeight.MEDIUM,
	fontSize: defaultFontSize * 0.875,
	htmlFontSize: 16,
	h1: {
		fontWeight: fontWeight.BOLD,
		fontSize: defaultFontSize * 3,
	},
	h2: {
		fontWeight: fontWeight.BOLD,
		fontSize: defaultFontSize * 2,
	},
	h3: {
		fontWeight: fontWeight.MEDIUM,
		fontSize: defaultFontSize * 1.5,
	},
	h4: {
		fontWeight: fontWeight.MEDIUM,
		fontSize: defaultFontSize * 1.25,
	},
	h5: {
		fontWeight: fontWeight.REGULAR,
		fontSize: defaultFontSize,
	},
	h6: {
		fontWeight: fontWeight.REGULAR,
		fontSize: defaultFontSize * 0.875,
	},
	button: {
		fontFamily: `'Inter', sans-serif, 'Noto Sans CJK TC', '微軟正黑體'`,
		fontWeight: fontWeight.MEDIUM,
	},
});
